import React from 'react';
import { useAppStore } from '../../../../../../GlobalStore/GlobalStore';

interface TooltipContentProps {
    content: string;
}

const TooltipContent: React.FC<TooltipContentProps> = ({ content }) => {
    const setDynamicStateObj = useAppStore((state: any) => state.setDynamicStateObj);
    
    const renderContent = () => {
        const parts = content.split(/(<a[^>]*>.*?<\/a>)/);
        
        return parts.map((part, index) => {
            if (part.startsWith('<a')) {
                // Extract href and text content
                const hrefMatch = part.match(/href=['"]([^'"]*)['"]/);
                const textMatch = part.match(/>([^<]*)</);
                const href = hrefMatch ? hrefMatch[1] : '#';
                const text = textMatch ? textMatch[1] : '';
                
                return (
                    <button
                        key={index}
                        className="text-blue-400 underline hover:text-blue-300"
                        onClick={(e) => {
                            e.preventDefault();
                            if (href.startsWith('settings:')) {
                                setDynamicStateObj({ visiblePopup: href });
                            } else {
                                window.open(href, '_blank');
                            }
                        }}
                    >
                        {text}
                    </button>
                );
            }
            return <span key={index}>{part}</span>;
        });
    };

    return <div className="tooltip-content">{renderContent()}</div>;
};

export default TooltipContent;